/**
 * @ngdoc directive
 * @name Classification Details
 *
 * @description
 Show transaction details inputs (classification - amount)
 when user clicks on last (empty) row, one more row with details added
 used on add/edit bill/vendor to show bill/default vendor details
 *
 * @scope
 * @param {Array} details - transactionDetails
 * @param {Array} classifications - array of tabulate journal accounts
 * @param {String} parentForm - name of the form where classification details are included
 * @param {Function} onAmountChange - callback on amount detail change
 *
 * @example
 <div ng-init='transactionDetails=[]'>
 <classification-details
 details="transactionDetails"
 classifications="classifications"
 parent-form="billForm"
 on-amount-change="alert"
 >
 </classification-details>
 </div>
 */

(function () {
  'use strict';

  directive.$inject = ["$timeout", "PATH"];
  app.directive('classificationDetails', directive);

  function directive($timeout, PATH) {
    controller.$inject = ["$scope"];
    return {
      scope: {
        details: '=',
        classifications: '=',
        parentForm: '=',
        onAmountChange: '=?'
      },
      controller: controller,
      restrict: 'E',
      templateUrl: PATH.components + 'classificationDetails/template.html'
    };

    function controller($scope) {
      $scope.$on('changeVendor', function (evt, data) {
        $scope.details = data;
      });
      $scope.newClassification = { classification: { caption: '' } };
      $scope.removeDetail = function (detail) {
        if (!detail.hasOwnProperty('classification')) {
          detail.classification = {};
          detail.index = 0;
        }
        _.remove($scope.details, detail);
        $scope.onAmountChange();
      };

      $('body').on('keydown', function (event) {
        var TAB_KEY = 9;
        if (event.keyCode === TAB_KEY) {
          event.preventDefault();
          event.stopPropagation();
          var eventName = event.target ? event.target.name : null;
          var parent = event.target.parentElement;
          if (eventName && (eventName.includes('classification') || eventName.includes('amount'))) {
            var name = eventName.includes('classification') ? 'classification' : 'amount';
            if (name === 'classification') {
              var amountControl = parent.parentElement.querySelector('.amount-control');
              amountControl.focus();
              amountControl.select();
            } else {
              event.target.blur();
              // eslint-disable-next-line max-len
              var classificationControl = parent.parentElement.nextElementSibling.querySelector('.classification-control');
              if (classificationControl) {
                classificationControl.focus();
                classificationControl.select();
              } else {
                // eslint-disable-next-line max-len
                var formControl = parent.parentElement.nextElementSibling.querySelector('.form-control');
                if (formControl) {
                  formControl.focus();
                  formControl.select();
                } else {
                  var btnPrimary = document.querySelector('.panel-new__content .btn-primary');
                  btnPrimary.focus();
                }
              }
            }
          }
          // eslint-disable-next-line brace-style
          else {
            // eslint-disable-next-line max-len
            var formControls = document.querySelectorAll('fieldset .non-classifications .form-control');
            formControls.forEach(function (formcontrol, index) {
              if (formcontrol === event.target && formControls[index + 1]) {
                formControls[index + 1].focus();
                formControls[index + 1].select();
                // eslint-disable-next-line max-len
              } else if (formcontrol === event.target && index + 1 > formControls.length - 1 && !formControls[index + 1]) {
                // eslint-disable-next-line no-shadow,max-len
                var classificationControl = document.querySelector('classification-details .classification-control');
                if (classificationControl) {
                  classificationControl.focus();
                  classificationControl.select();
                } else {
                  $scope.addRow('classification', true);
                  $scope.$digest();
                }
              }
            });
          }
        }
      });

      $scope.addRow = function (elementName, focus) {
        var debitCredit = ($scope.details && $scope.details.length) ? $scope.details[0].debitCredit : 'Debit';
        $scope.details.push({
          // eslint-disable-next-line max-len
          classification: $scope.newClassification.classification ? _.clone($scope.newClassification.classification) : {},
          debitCredit: debitCredit,
          index: $scope.details.length
        });
        var wasAdded = false;
        var target = document.getElementById('classification-details');
        var config = {
          attributes: false,
          childList: true,
          subtree: false
        };
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        if (focus) {
          var callback = function (mutationsList, observer) {
            try {
              // eslint-disable-next-line no-undef
              for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var mutation = _step.value;
                if (mutation.type === 'childList' && !wasAdded) {
                  var classificationControls = document.querySelectorAll('classification-details .classification-control');
                  classificationControls[classificationControls.length - 1].focus();
                  classificationControls[classificationControls.length - 1].select();
                  $scope.$digest();
                  wasAdded = true;
                  observer.disconnect();
                }
              }
            } finally {
              try {
                // eslint-disable-next-line block-scoped-var
                if (!_iteratorNormalCompletion && _iterator.return) {
                  // eslint-disable-next-line block-scoped-var
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          };
          var observer = new MutationObserver(callback);
          observer.observe(target, config);
        }
      };
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/classificationDetails/directive.js